import React from "react";
import { GatsbyImageProps } from "gatsby-plugin-image";
import {
	ArrowBottomLeft,
	ArrowBottomRight,
	ArrowTopLeft,
	ArrowTopRight,
	Frame,
	Focus,
} from "./styles";
import styled from "styled-components";

interface Props {
	onClick?: () => void;
	children:
		| React.ReactElement<HTMLImageElement>
		| React.FunctionComponent<GatsbyImageProps>;
	className?: string;
}

const GalleryIntro: React.FC<Props> = (props) => {
	const { onClick, children, className } = props;
	return (
		<Frame className={className} onClick={onClick}>
			{children}
			<Focus width="34" height="34">
				<path
					d="M 14 0 L 20 0 L 20 34 L 14 34 Z"
					fill="hsl(0, 0%, 100%)"
					data-projection-id="12"
				></path>
				<path
					d="M 0 14 L 34 14 L 34 20 L 0 20 Z"
					fill="hsl(0, 0%, 100%)"
					data-projection-id="13"
				></path>
			</Focus>

			<ArrowTopLeft width="20" height="20">
				<path
					d="M 20 0 L 0 0 L 0 20"
					fill="transparent"
					strokeWidth="9"
					stroke="rgb(26,48,129)"
					strokeMiterlimit="10"
					strokeDasharray=""
					data-projection-id="8"
				></path>
			</ArrowTopLeft>
			<ArrowTopRight width="20" height="20">
				<path
					d="M 0 0 L 20 0 L 20 20"
					fill="transparent"
					strokeWidth="9"
					stroke="rgb(26,48,129)"
					strokeMiterlimit="10"
					strokeDasharray=""
					data-projection-id="8"
				></path>
			</ArrowTopRight>
			<ArrowBottomLeft width="20" height="20">
				<path
					d="M -0 0 L -0 20 L 20 20"
					fill="transparent"
					strokeWidth="9"
					stroke="rgb(26,48,129)"
					strokeMiterlimit="10"
					strokeDasharray=""
					data-projection-id="7"
				></path>
			</ArrowBottomLeft>
			<ArrowBottomRight width="20" height="20">
				<path
					d="M 20 0 L 20 20 L 0 20"
					fill="transparent"
					strokeWidth="9"
					stroke="rgb(26,48,129)"
					strokeMiterlimit="10"
					strokeDasharray=""
					data-projection-id="3"
				></path>
			</ArrowBottomRight>
		</Frame>
	);
};

export default styled(GalleryIntro)``;
